// ContactSection.js
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";

const SERVICE_ID = "service_5pnerir";
const TEMPLATE_ID = "template_9tvt75j";
const PUBLIC_KEY = "U5WsPa3AzTs-YMmCq";

// ✅ Clé TEST Google (fonctionne en localhost)
const RECAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    sujet: "",
    nom: "",
    email: "",
    message: "",
  });

  const [sending, setSending] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const formRef = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Vérification des champs
    if (
      !formData.sujet.trim() ||
      !formData.nom.trim() ||
      !formData.email.trim() ||
      !formData.message.trim()
    ) {
      alert("Veuillez remplir tous les champs.");
      return;
    }

    // ✅ Vérification du captcha
    if (!captchaValue) {
      alert("Veuillez confirmer que vous n'êtes pas un robot.");
      return;
    }

    setSending(true);

    const templateParams = {
      sujet: formData.sujet,
      nom: formData.nom,
      email: formData.email,
      message: formData.message,
    };

    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      );

      alert("Message envoyé avec succès ✅");
      setFormData({ sujet: "", nom: "", email: "", message: "" });
      setCaptchaValue(null);
    } catch (error) {
      console.error("Erreur EmailJS :", error);
      alert("Erreur lors de l'envoi du message.");
    }

    setSending(false);
  };

  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  return (
    <section className="contact-section contact-section1">
      <div className="contact-map" data-aos="zoom-out-up">
        <iframe
          title="Unik System"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2668.8671237084964!2d-7.499121625389491!3d33.63056913988009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7d2621b5904af%3A0xbb18fdcc324a572e!2sUnik%20System!5e1!3m2!1sen!2sma!4v1764590623143!5m2!1sen!2sma"
          width="100%"
          height="550"
          style={{ border: 0 }}
          loading="lazy"
        />
      </div>

      <div data-aos="zoom-in-right" className="contact-wrapper">
        <form className="contact-form" onSubmit={handleSubmit} ref={formRef}>
          <input
            type="text"
            name="sujet"
            placeholder="Sujet"
            value={formData.sujet}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="nom"
            placeholder="Nom"
            value={formData.nom}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />

          {/* ✅ reCAPTCHA */}
          <div style={{ margin: "15px 0" }}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={onCaptchaChange}
            />
          </div>

          <button type="submit" disabled={sending}>
            {sending ? "Envoi..." : "Envoyer"}
          </button>
        </form>

        {/* Coordonnées */} 
        <div data-aos="zoom-in-left" className="contact-info"> 
          <h3>NOS COORDONNEES</h3> 
          <p> 
            <strong>Adresse :</strong>
             <br /> Route 110, Boulevard Chefchaouni – Km 12.5 
             <br /> Casablanca – 20100, Maroc 
          </p>
          <p> 
            <strong>Téléphone :</strong> 
            <br /> +212 5 22 20 27 12 
            <br /> +212 6 71 01 88 19 
            <br /> +212 6 79 31 68 71 
          </p> 
          <p> <strong>Email :</strong> 
          contact@unik-system.com <br /> 
          <strong>Site Web :</strong>{" "} 
          <Link to="https://www.unik-system.com" target="_blank"> www.unik-system.com </Link> 
          </p> 
          <p> 
            <strong>Horaires d’ouverture :</strong> 
            <br /> Lundi – Vendredi : 08h30 À 12h30 / 14h00 À 18h30 
            <br /> Samedi Matin : 9h00 À 13h00 
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
